import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../assets/css/icons.css";
import "../assets/css/style.css";
import QrModal from "../common/ScanQR";

import AppDrawer from "./AppDrawer";
import Notifications from "../FormController/Dashboard/Notifications";
import { SERVER_IP, ud, jwt, logout } from "../Server";
import user_img from "../assets/images/user/user.svg";
import sun from "../assets/images/sun.png";
import { ScanQRIcon, SignOutIcon } from "../assets/Icons";
import { useSelector } from "react-redux";
import ScanQR from "../common/ScanQR";

export default function TopNavBar() {
  const [time, setTime] = useState(new Date().toLocaleString());
  const [notificationCount, setNotificationCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const user = useSelector((state) => state?.userData);
  const userDetails = user?.userDetails?.user;

  const name = userDetails?.name || "User";
  const designation = userDetails?.designation || "Member";
  const email = userDetails?.email || userDetails?.uid || userDetails?.phone || "";
  const image = userDetails?.avatar || user_img;
  const [newNotification, setNewNotification] = useState([]);
  const dropdownRef = useRef(null);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const placeholderUserName = name
    ?.split(" ")
    ?.slice(0, 2)
    ?.map((e) => e.charAt(0)?.toUpperCase())
    ?.join("");

  const profileLinks = [
    ...(ud?.usertype !== 0
      ? [{ label: "Profile", handleManageProfileClick: () => (window.location.href = "/create/profile") }]
      : []),
    {
      label: "Change Password",
      handleManageProfileClick: () => (window.location.href = "/create/changepassword"),
    },
  ];

  // useEffect(() => {
  //   const intervalID = setInterval(() => {
  //     setTime(new Date().toLocaleString());
  //     fetchNotificationCount();
  //   }, 10000);
  //   return () => clearInterval(intervalID);
  // }, []);

  const fetchNotificationCount = async () => {
    try {
      const headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };
      const result = await axios.get(`${SERVER_IP}/user/notification/count`, { headers });
      setNotificationCount(result.data.notificationcount || 0);
    } catch (error) {
      console.error(error);
    }
  };

  const showLeftNavbar = () => {
    const leftbar = document.getElementsByClassName("xp-leftbar")[0];
    const topbar = document.getElementsByClassName("xp-topbar")[0];
    const rightbar = document.getElementsByClassName("xp-rightbar")[0];
    const expanded = leftbar.style.width === "60px";

    leftbar.style.width = expanded ? "250px" : "60px";
    topbar.style.left = expanded ? "250px" : "60px";
    rightbar.style.marginLeft = expanded ? "250px" : "60px";
    leftbar.classList.toggle("smallmenus", !expanded);
  };

  useEffect(() => {
    const leftbar = document.getElementsByClassName("xp-leftbar")[0];
    const topbar = document.getElementsByClassName("xp-topbar")[0];
    const rightbar = document.getElementsByClassName("xp-rightbar")[0];

    if (leftbar && topbar && rightbar) {
      leftbar.style.width = "60px";
      topbar.style.left = "60px";
      rightbar.style.marginLeft = "60px";
      leftbar.classList.add("smallmenus");
    }
  }, []);
  // document.body.classList.add(localStorage.getItem("light_DarkMode") || "lightmode");

  const toggleDarkMode = (mode) => {
    document.body.classList.remove("darkmode", "lightmode");
    document.body.classList.add(mode);
    localStorage.setItem("light_DarkMode", mode);
  };
  const scanQRModal = () => {
    setShowModal(true);
  };

  const showIconForNotification = (newNotification) => {
    const now = new Date();
    const threeMinutesAgo = new Date(now.getTime() - 3 * 60 * 1000);
    const data = newNotification.filter((n) => {
      if (!n.time) return false;
      const notifTime = new Date(n.time);
      return n.seen && notifTime >= threeMinutesAgo;
    });
    return data.length;
  };

  const handleRemoveNotification = () => {
    setNewNotification((prev) =>
      prev.map((n) => ({
        ...n,
        seen: false,
      }))
    );
  };

  const toggleNotificationDropdown = () => {
    setIsNotificationOpen((prev) => {
      const newState = !prev;
      if (newState) {
        console.log("Notification dropdown opened");
      }
      return newState;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isNotificationOpen) {
      handleRemoveNotification();
    }
  }, [isNotificationOpen]);

  return (
    <>
      <div className="xp-topbar">
        <div className="row">
          <div className="col-2 col-md-1 col-lg-1 align-self-center">
            <div className="xp-menubar">
              <a className="xp-menu-hamburger resmenu" onClick={showLeftNavbar}>
                <i className="icon-menu font-18"></i>
              </a>
            </div>
          </div>

          <div className="col-10 col-md-11 col-lg-11">
            <div className="xp-profilebar text-right">
              <ul className="list-inline mb-0 d-flex align-items-center justify-content-end gap-2">
                {/* Optional Dark/Light Toggle */}
                {/* <li className="list-inline-item darklightmode">
                  <a onClick={() => toggleDarkMode("darkmode")} className="darkmodemoon">
                    <i className="fa fa-moon-o" />
                  </a>
                  <a onClick={() => toggleDarkMode("lightmode")} className="lightmodesun">
                    <img src={sun} style={{ width: "23px" }} alt="Sun" />
                  </a>
                </li> */}

                {/* Notification */}
                <li className="list-inline-item" style={{ marginRight: "0px" }}>
                  <div className="dropdown notification" ref={dropdownRef}>
                    <div className=" dropdown-toggle" onClick={toggleNotificationDropdown}>
                      <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.8608 20.6314C6.19789 20.5521 4.5379 20.4202 2.88332 20.236C2.56964 20.2011 2.26773 20.0966 1.99967 19.93C1.73161 19.7634 1.50419 19.539 1.33404 19.2732C1.16389 19.0073 1.05532 18.7068 1.01627 18.3936C0.97722 18.0804 1.00868 17.7625 1.10834 17.463C1.32437 16.8149 1.54166 16.177 1.59978 15.4897L2.07227 9.80985C2.27327 7.40791 3.36941 5.16915 5.14342 3.5374C6.91743 1.90564 9.23979 1 11.6501 1C14.0605 1 16.3828 1.90564 18.1568 3.5374C19.9308 5.16915 21.027 7.40791 21.228 9.80985L21.7017 15.4935C21.7586 16.1795 21.9759 16.8175 22.1919 17.4656C22.2911 17.7649 22.3222 18.0826 22.283 18.3954C22.2437 18.7083 22.135 19.0085 21.9649 19.274C21.7948 19.5395 21.5676 19.7636 21.2998 19.9301C21.0319 20.0965 20.7303 20.2011 20.4169 20.236C18.762 20.4192 17.102 20.5518 15.4407 20.6302M7.8608 20.6314V21.21C7.8608 22.2152 8.2601 23.1792 8.97085 23.8899C9.68161 24.6007 10.6456 25 11.6508 25C12.6559 25 13.6199 24.6007 14.3307 23.8899C15.0414 23.1792 15.4407 22.2152 15.4407 21.21V20.6302M7.8608 20.6314C10.3862 20.7514 12.9153 20.7514 15.4407 20.6302"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {!!showIconForNotification(newNotification) && <div className="count">{""}</div>}
                      {/* <div className="count">"{notificationCount}"</div> */}
                    </div>
                    <div className={`dropdown-menu ${isNotificationOpen ? "show" : ""}`}>
                      <Notifications setNewNotification={setNewNotification} newNotification={newNotification} />
                    </div>
                  </div>
                </li>

                {/* User Profile Dropdown */}
                <li className="list-inline-item mr-0">
                  <div className="dropdown xp-userprofile">
                    <div
                      className="profile-info dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span className="name-email">
                        <h6>{name}</h6>
                        <p>{designation}</p>
                      </span>

                      {image ? (
                        <img src={image} referrerPolicy="no-referrer" alt="User" className="rounded-circle img-fluid" />
                      ) : (
                        <span className="placeholder">{placeholderUserName}</span>
                      )}
                      <span className="xp-user-live" />
                    </div>

                    <div className="dropdown-menu profile-detail-parent p-0">
                      <div className="profile-detail">
                        <div className="bg">
                          {image ? (
                            <img src={image} referrerPolicy="no-referrer" alt="User" />
                          ) : (
                            <span>{placeholderUserName}</span>
                          )}
                        </div>

                        <span className="name-email">
                          <p>{name}</p>
                          <p className="email">{email}</p>
                          <p className="designation">{designation}</p>
                        </span>

                        <span className="signout">
                          <span onClick={() => scanQRModal()}>
                            <ScanQRIcon />
                            Scan QR
                          </span>
                          <span onClick={logout.logout}>
                            <SignOutIcon />
                            Sign Out
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </li>

                {/* App Drawer */}
                <li className="list-inline-item mr-0">
                  <AppDrawer />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {showModal && <ScanQR show={showModal} onHide={() => setShowModal(false)} />}
    </>
  );
}
